module.exports = __webpack_public_path__ + "img/11.93773ec5.png";